
export const Arrow = ({ width = 11, height = 6 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 0.5L5.5 5.5L10.5 0.5H0.5Z" fill="#666666" />
        </svg>

    )
}
